"use strict";

var Constants = require("../designer/Constants");

var Dispatcher = require("../dispatcher/Dispatcher");

var SlideShowStore = require("../stores/SlideShowStore");

var getValidSlideIndex = function (currentSlideIndex, $slides) {
	if (currentSlideIndex == null || currentSlideIndex > $slides.length - 1) { //coercion: undefined == null is true
		return 0;
	}
	if (currentSlideIndex < 0) {
		return $slides.length - 1;
	}
	return currentSlideIndex;
};

// Currently, only one slideShow is allowed per layout, if this changes this implementation will also have to change

var SlideShowActions = {
	initializeStore: function (options) {
		var action = Object.assign({}, options, { actionType: Constants.SLIDESHOW_INITIALIZE });
		Dispatcher.dispatch(action);
		this.startSlideShow();
	},

	initializeSlideShow: function () {
		document.addEventListener("DOMContentLoaded", (event) => {
			var handleTouchStart = function (event) {
				SlideShowActions.handleTouchStart(event);
			};
			var handleTouchEnd = (event) => {
				SlideShowActions.handleTouchEnd(event);
				SlideShowActions.handleSwipe(event);

				var $target = this.getTargetDataComponent($(event.target));

				if ($target.attr("data-component") === "slideShow.previous"
					|| $target.attr("data-component") === "slideShow.next") {
					event.preventDefault();
				}

				event.stopPropagation();
			};

			if (typeof document.querySelectorAll === "function") {
				var slideShows = document.querySelectorAll("[data-component='slideShow']");

				if (slideShows.length) {
					slideShows[0].addEventListener("touchstart", handleTouchStart);
					slideShows[0].addEventListener("touchend", handleTouchEnd);
				}
			}
			SlideShowActions.initializeStore({
				isDesignMode: false
			});
		});
	},

	getTargetDataComponent: function ($target) {
		if (!$target.attr("data-component") || !$target.attr("data-component").indexOf("slideShow") !== 0) {
			$target = $target.closest("[data-component^='slideShow']");
		}

		return $target;
	},

	animateSlideTransition: function ($slides, $pages, currentSlideIndex, nextSlideIndex) {
		var $outgoingSlide = $slides.eq(currentSlideIndex);
		var $incomingSlide = $slides.eq(nextSlideIndex);
		var outgoingZindex = $outgoingSlide.css("z-index");
		var incomingZindex = $incomingSlide.css("z-index");

		// Set the z-index to make sure the next slide moves over the top of the current one.
		// Otherwise the first slide will slide under the last slide when transitioning from
		//		from the last to the first because of order of declaration.
		$outgoingSlide.css("z-index", 900 - $slides.length);
		$incomingSlide.css({
			"margin-left": $incomingSlide.css("width"),
			"z-index": 900 + (+nextSlideIndex) //nextSlideIndex can be a string: "2" so cast to int before adding (900 + "2" = "9002")
		}).addClass("selected").animate({ "margin-left": 0 }, 750, "linear", function () {
			$(this).siblings().removeClass("selected");
			$pages.removeClass("selected").eq(nextSlideIndex).addClass("selected");
			$outgoingSlide.css("z-index", outgoingZindex);
			$(this).css("z-index", incomingZindex);
			Dispatcher.dispatch({
				actionType: Constants.SLIDESHOW_CHANGE_SLIDE,
				slideIndex: nextSlideIndex
			});
			if (SlideShowStore.get("intervalId") == null) { // coercion
				SlideShowActions.startSlideShow();
			}
		});
	},

	startSlideShow: function (event) {
		if (SlideShowStore.get("isDesignMode")) {
			return false;
		}

		var $slideShow = $("[data-component='slideShow']").first();
		var pauseTime = $slideShow.attr("data-pause-time") || 3000; //3 second default

		Dispatcher.dispatch({
			actionType: Constants.SLIDESHOW_STARTED,
			intervalId: setInterval((event) => {
				this.advanceSlideShow(event);
			}, pauseTime)
		});
	},

	stopSlideShow: function (event) {
		if (!event || !event.target || (event.type !== "mouseover" && event.type !== "touchstart") || SlideShowStore.get("isDesignMode")) {
			return false;
		}

		Dispatcher.dispatch({
			actionType: Constants.SLIDESHOW_STOPPED
		});
	},

	advanceSlideShow: function (event) {
		if (SlideShowStore.get("isDesignMode")) {
			return false;
		}

		var $slideShow;

		if (event) {
			$slideShow = $(event.target).closest("[data-component='slideShow']");
		} else {
			$slideShow = $("[data-component='slideShow']").first();
		}

		var $slideDeck = $slideShow.find("[data-component='slideShow.slideDeck']").first();
		var $slides = $slideDeck.children();
		var $paging = $slideShow.find("[data-component='slideShow.paging']").first();
		var $pages = $paging.children("[data-component='slideShow.paging.page']");
		var slideIndex = SlideShowStore.get("slideIndex");

		slideIndex = getValidSlideIndex(slideIndex, $slides);

		var nextSlideIndex = slideIndex + 1 > $slides.length - 1 ? 0 : slideIndex + 1;
		this.animateSlideTransition($slides, $pages, slideIndex, nextSlideIndex);
	},

	showSlide: function (event, touchEndSlideIndex) {
		var isDesignMode = SlideShowStore.get("isDesignMode");

		if (!event || !event.target || (isDesignMode && !event.ctrlKey && !event.metaKey)) {
			return false;
		}

		var $target = this.getTargetDataComponent($(event.target));

		var $slideShow = $target.closest("[data-component='slideShow']");
		var $slideDeck = $slideShow.find("[data-component='slideShow.slideDeck']").first();
		var $slides = $slideDeck.children();
		var $paging = $slideShow.find("[data-component='slideShow.paging']").first();
		var $pages = $paging.children("[data-component='slideShow.paging.page']");
		var slideIndex = getValidSlideIndex($slides.index($slideDeck.find(".selected")), $slides);

		if (event.type === "click" && !isDesignMode) {
			event.preventDefault();
			event.stopPropagation();
		}

		var nextSlideIndex = slideIndex;
		switch ($target.attr("data-component")) {
			case "slideShow.previous":
				nextSlideIndex--;
				if (nextSlideIndex < 0) {
					nextSlideIndex = $slides.length - 1;
				}
				this.animateSlideTransition($slides, $pages, slideIndex, nextSlideIndex);
				break;
			case "slideShow.next":
				nextSlideIndex++;
				if (nextSlideIndex > $slides.length - 1) {
					nextSlideIndex = 0;
				}
				this.animateSlideTransition($slides, $pages, slideIndex, nextSlideIndex);
				break;
			case "slideShow.paging.page":
				var page = +$target.attr("rel");
				if (page !== slideIndex) {
					nextSlideIndex = page;
				} else {
					return true;
				}
				this.animateSlideTransition($slides, $pages, slideIndex, nextSlideIndex);
				break;
			case "slideShow.slideDeck.slide":
				if (event.type === "touchend" && touchEndSlideIndex != null && slideIndex !== touchEndSlideIndex) { //coercion
					this.animateSlideTransition($slides, $pages, slideIndex, touchEndSlideIndex);
				} else if (event.type === "touchend" && slideIndex === touchEndSlideIndex) {
					this.startSlideShow();
				}
				break;
			default:
				console.log(`${$target.attr("data-component")}: ${event.type}`);
				break;
		}

		return false;
	},

	setActiveSlide(slideIndex) {
		Dispatcher.dispatch({
			actionType: Constants.SLIDESHOW_CHANGE_SLIDE,
			slideIndex: slideIndex
		});
	},

	// Swipe logic
	handleTouchStart(event) {
		if (event && event.changedTouches) {
			this.stopSlideShow(event);
			Dispatcher.dispatch({
				actionType: Constants.SLIDESHOW_TOUCH_START,
				touchstartX: event.changedTouches[0].screenX
			});
		}
		return false;
	},

	handleTouchEnd(event) {
		if (event && event.changedTouches) {
			Dispatcher.dispatch({
				actionType: Constants.SLIDESHOW_TOUCH_END,
				touchendX: event.changedTouches[0].screenX
			});
		}
		return false;
	},

	handleSwipe(event) {
		var swipeBuffer = 15; // If the diff between toundstartX and touchendX is less than swipeBuffer, don't count it as a swipe
		var touchstartX = SlideShowStore.get("touchstartX");
		var touchendX = SlideShowStore.get("touchendX");
		var touchDiff = Math.abs(touchstartX - touchendX);
		var slideIndex = SlideShowStore.get("slideIndex");
		var $target = this.getTargetDataComponent($(event.target));

		var $slideShow = $target.closest("[data-component='slideShow']");
		var $slideDeck = $slideShow.find("[data-component='slideShow.slideDeck']").first();
		var $slides = $slideDeck.children();

		if (slideIndex == null) { // coercion
			slideIndex = $slides.index($slideDeck.children(".selected"));
		}

		if (touchDiff > swipeBuffer) {
			if (touchendX < touchstartX) {
				this.showSlide(event, getValidSlideIndex(++slideIndex, $slides)); // Next slide
			} else {
				this.showSlide(event, getValidSlideIndex(--slideIndex, $slides)); // Previous slide
			}
		} else {
			this.showSlide(event, getValidSlideIndex(slideIndex, $slides));
		}
	}
};

module.exports = SlideShowActions;